import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { Col, Button, Row, Label } from 'reactstrap';
import { kebabCase } from 'lodash';
import classnames from 'classnames';
import DateTimePicker from '../../common/controls/dateTimePicker';
import { getURL } from '../../../actions/ajax';
import { getUser } from '../../common/classes/permissions';
import Icon from '../../common/containers/icon';
import ListPanel from '../../common/containers/listPanel';
import SinglePicker from '../../common/controls/singlePicker';
import MultiPicker from '../../common/controls/multiPicker';
import WhatsThis from '../../common/controls/whatsThis';
import entityComposition from '../../common/classes/entityComposition';
const handleDownload = () => {
  const element = global.document.getElementById('csvForm');
  if (element) {
    element.submit();
  }
};
const timezoneInfo = 'TRU stores all dates and times in UTC. Adjust this field to change the start and end times to your timezone of choice or leave the field blank to receive results in UTC.';
const buildFilters = function buildFilters(dataFilters) {
  let indexDefinitions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const transformIndex = index => {
    const definition = indexDefinitions[index];
    if (!(definition !== null && definition !== void 0 && definition.referenceIndex)) {
      return {
        filterKey: 'name',
        index
      };
    }
    return {
      filterKey: 'id',
      index: definition.referenceIndex
    };
  };
  const indexes = Object.keys(dataFilters);
  const filters = indexes.map(filterIndex => {
    const _transformIndex = transformIndex(filterIndex),
      filterKey = _transformIndex.filterKey,
      index = _transformIndex.index;
    const filterValues = dataFilters[filterIndex];
    return filterValues.map(filter => encodeURIComponent("".concat(index, "=").concat(filter[filterKey]))).join('&filters=');
  });
  return filters;
};
const Summary = _ref => {
  let selectedSummary = _ref.selectedSummary,
    jobs = _ref.jobs,
    _ref$summaryFilterOpt = _ref.summaryFilterOptions,
    summaryFilterOptions = _ref$summaryFilterOpt === void 0 ? {} : _ref$summaryFilterOpt,
    optionsServerFilter = _ref.summaryFilterOptionsActions.serverFilter,
    notificationActions = _ref.notificationActions,
    settings = _ref.settings;
  const _settings$settings = settings.settings,
    _settings$settings2 = _settings$settings === void 0 ? {} : _settings$settings,
    _settings$settings2$i = _settings$settings2.indexDefinitions,
    indexDefinitions = _settings$settings2$i === void 0 ? {} : _settings$settings2$i;

  // Build the list of Sundays from the nearest Sunday in the future
  // back to n weeks
  const weeksOfSundays = 210; // Lets go back just over 4 years
  const AllSundays = [];
  for (let i = -1; i < weeksOfSundays; i += 1) {
    AllSundays.push({
      id: moment().day(-7 * i).format('MM/DD/YYYY'),
      name: moment().day(-7 * i).format('MM/DD/YYYY')
    });
  }
  const timezones = momentTimezone.tz.names().map(name => ({
    id: name,
    name
  }));
  const currentTimezone = moment.tz.guess();
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    weekEnding = _useState2[0],
    setWeekEnding = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    startDate = _useState4[0],
    setStartDate = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    endDate = _useState6[0],
    setEndDate = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedJobs = _useState8[0],
    setSelectedJobs = _useState8[1];
  const _useState9 = useState(AllSundays),
    _useState0 = _slicedToArray(_useState9, 1),
    sundays = _useState0[0];
  const _useState1 = useState({
      name: currentTimezone,
      id: currentTimezone
    }),
    _useState10 = _slicedToArray(_useState1, 2),
    timezone = _useState10[0],
    setTimezone = _useState10[1];
  const _useState11 = useState(timezones),
    _useState12 = _slicedToArray(_useState11, 1),
    timezonesState = _useState12[0];
  const _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    summaryIdentifier = _useState14[0],
    setSummaryIdentifier = _useState14[1];
  const _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    filterIndexes = _useState16[0],
    setFilterIndexes = _useState16[1];
  const _useState17 = useState({}),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedFilters = _useState18[0],
    setSelectedFilters = _useState18[1];
  useEffect(() => {
    if (selectedSummary.query) {
      const regex = /CONTENT_INDEX\((.*?)\)/g;
      const matches = [...selectedSummary.query.matchAll(regex)];
      const extractedFilterIndexes = matches.map(match => match[1]);
      setFilterIndexes(extractedFilterIndexes);
    }
  }, [selectedSummary.query]);
  useEffect(() => {
    if (selectedSummary.identifier) {
      setSummaryIdentifier(selectedSummary.identifier);
    }
  }, [selectedSummary.identifier]);
  useEffect(() => {
    const fetchOptionsSequentially = async () => {
      if (summaryIdentifier && filterIndexes.length > 0) {
        for (let i = 0; i < filterIndexes.length; i += 1) {
          const filterIndex = filterIndexes[i];
          try {
            // eslint-disable-next-line no-await-in-loop
            await optionsServerFilter(summaryIdentifier, filterIndex);
          } catch (error) {
            throw new Error("Failed fetching options for ".concat(filterIndex));
          }
        }
      }
    };
    fetchOptionsSequentially();
  }, [optionsServerFilter, summaryIdentifier, filterIndexes]);
  const camelCaseToTitle = str => {
    const words = str.replace(/([A-Z])/g, ' $1');
    return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
  };
  const getSummaryUrl = () => {
    let url = "/summary/".concat(summaryIdentifier, "?");

    // Attach the auth as a query parameter
    if (weekEnding) {
      url += "week_ending=".concat(weekEnding.name);
    } else if (startDate && endDate) {
      let adjustedStart = startDate;
      let adjustedEnd = endDate;
      if (timezone) {
        // adjust the selected dates, which are in the browsers local timezone to the
        // selected timezone. Note that timezones west of UTC will have a negative
        // offset
        const currentTimeZone = moment.tz.guess();
        const currentTimezoneOffset = moment.tz(moment.utc(), currentTimeZone).utcOffset();
        const selectedTimezoneOffset = moment.tz(moment.utc(), timezone.name).utcOffset();
        adjustedStart = moment.utc(startDate).add(currentTimezoneOffset, 'minutes') // add the offset back to get to UTC
        .startOf('day') // set time to 00:00:00 UTC
        .subtract(selectedTimezoneOffset, 'minutes') // subtract the offset to get to tz
        .format(); // must use format, toISOString will return UTC
        adjustedEnd = moment.utc(endDate).add(currentTimezoneOffset, 'minutes').endOf('day') // set time to 23:59:59 UTC
        .subtract(selectedTimezoneOffset, 'minutes').format();
      }
      url += "start=".concat(adjustedStart, "&stop=").concat(adjustedEnd);
      url += timezone ? "&timezone=".concat(timezone.name) : '';
    }
    if (selectedSummary.hasJob && selectedJobs) {
      const jobString = selectedJobs.map(job => job.id).join(',');
      url += "&jobs=".concat(jobString);
    }
    if (Object.keys(selectedFilters).length > 0) {
      const dataToAppend = buildFilters(selectedFilters, indexDefinitions);
      url += "&filters=".concat(dataToAppend.join('&filters='));
    }
    return getURL(url);
  };
  const handleJobSelection = selection => {
    setSelectedJobs(selection);
  };
  const handleDownloadButton = () => {
    const hasStart = selectedSummary.hasStart,
      hasStop = selectedSummary.hasStop;
    const needsDateValidation = hasStart && hasStop;
    if (needsDateValidation && moment(startDate).isAfter(endDate, 'date')) {
      return notificationActions.validationError({
        message: 'Your end date is before your start date!'
      });
    }
    handleDownload();
    return notificationActions.success({
      message: 'Your summary is downloading now...'
    });
  };

  /**
   *  Set the date received from dateTimePicker in state. dateTimePicker returns
   *  an ISO 8601 date adjusted for the current browser's timezone
   */
  const handleDateChange = (datePickerName, updatedDate) => {
    const dateSetters = {
      weekEnding: setWeekEnding,
      startDate: setStartDate,
      endDate: setEndDate,
      timezone: setTimezone
    };
    const setDateState = dateSetters[datePickerName];
    if (setDateState) {
      setDateState(updatedDate);
    }
  };
  const handleFilterSelection = filterIndex => selection => {
    setSelectedFilters(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [filterIndex]: selection
    }));
  };
  const hasWeekEnding = selectedSummary.hasWeekEnding,
    hasStart = selectedSummary.hasStart,
    hasStop = selectedSummary.hasStop;
  const downloadEnabled = startDate && endDate || hasStart && !hasStop && startDate || hasStop && !hasStart && endDate || hasWeekEnding && weekEnding || !hasWeekEnding && !hasStart && !hasStop;

  // d-none is the bootstrap classname for display: none
  const weekEndingClasses = classnames({
    'd-none': !hasWeekEnding,
    weekEnding: true
  });
  const timeRangeClasses = classnames({
    'd-none': !hasStart && !hasStop,
    timeRange: true
  });
  const jobPickerClasses = classnames({
    'd-none': !selectedSummary.hasJob,
    jobPicker: true
  });
  const timeStartClasses = classnames({
    'd-none': !hasStart,
    timeStart: !hasStart,
    timeRange: true
  });
  const timeStopClasses = classnames({
    'd-none': !hasStop,
    timeStop: !hasStop,
    timeRange: true
  });
  return /*#__PURE__*/React.createElement(ListPanel, {
    title: selectedSummary.name,
    showNew: false
  }, selectedSummary.name !== selectedSummary.note ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "t-s-".concat(kebabCase(selectedSummary.note))
  }, selectedSummary.note), /*#__PURE__*/React.createElement("hr", null)) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12,
    className: jobPickerClasses
  }, /*#__PURE__*/React.createElement(Label, null, "Jobs (Optional)"), /*#__PURE__*/React.createElement(MultiPicker, {
    className: "t-s-job-picker",
    labelKey: "jobNumber",
    valueKey: "id",
    options: jobs,
    values: selectedJobs,
    placeholder: "Select Job...",
    onChange: handleJobSelection
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: weekEndingClasses
  }, /*#__PURE__*/React.createElement(Label, null, "Week Ending"), /*#__PURE__*/React.createElement(SinglePicker, {
    className: "t-s-week-ending",
    name: "weekEnding",
    options: sundays,
    value: weekEnding,
    placeholder: "Select Sunday...",
    onChange: value => handleDateChange('weekEnding', value)
  })), /*#__PURE__*/React.createElement(Row, {
    style: {
      width: '100%',
      marginRight: '0',
      marginLeft: '0'
    }
  }, filterIndexes.length > 0 && filterIndexes.map(filterIndex => {
    var _summaryFilterOptions, _summaryFilterOptions2;
    // Check if the list exists and has items
    const hasListData = ((_summaryFilterOptions = summaryFilterOptions[summaryIdentifier]) === null || _summaryFilterOptions === void 0 || (_summaryFilterOptions = _summaryFilterOptions[filterIndex]) === null || _summaryFilterOptions === void 0 || (_summaryFilterOptions = _summaryFilterOptions.list) === null || _summaryFilterOptions === void 0 ? void 0 : _summaryFilterOptions.length) > 0;

    // Only render the picker if there is data
    return hasListData && /*#__PURE__*/React.createElement(Col, {
      sm: 6,
      key: filterIndex
    }, /*#__PURE__*/React.createElement(Label, null, camelCaseToTitle(filterIndex)), /*#__PURE__*/React.createElement(MultiPicker, {
      className: "t-s-filter-picker",
      labelKey: "name",
      valueKey: "id",
      options: ((_summaryFilterOptions2 = summaryFilterOptions[summaryIdentifier]) === null || _summaryFilterOptions2 === void 0 || (_summaryFilterOptions2 = _summaryFilterOptions2[filterIndex]) === null || _summaryFilterOptions2 === void 0 ? void 0 : _summaryFilterOptions2.list) || [],
      values: selectedFilters[filterIndex] || [],
      placeholder: "Select filter...",
      onChange: handleFilterSelection(filterIndex)
    }));
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: timeStartClasses
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    label: "Start",
    dateFormat: "MM/DD/YYYY",
    defaultValue: startDate,
    onChange: value => handleDateChange('startDate', value)
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: timeStopClasses
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    label: "End",
    dateFormat: "MM/DD/YYYY",
    defaultValue: endDate,
    onChange: value => handleDateChange('endDate', value)
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: timeRangeClasses
  }, /*#__PURE__*/React.createElement(Label, null, "Timezone\xA0", /*#__PURE__*/React.createElement(WhatsThis, {
    text: timezoneInfo
  })), /*#__PURE__*/React.createElement(SinglePicker, {
    className: "t-s-timezone",
    name: "timezone",
    options: timezonesState,
    value: timezone,
    onChange: value => handleDateChange('timezone', value)
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: "form-group"
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "t-s-button-download",
    size: "sm",
    label: "Download",
    onClick: handleDownloadButton,
    disabled: !downloadEnabled,
    className: "float-md-right pull-down form-control t-s-download tqc-control"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "download"
  }), " Download"))), /*#__PURE__*/React.createElement("iframe", {
    title: "csvContainer",
    src: "",
    name: "csvContainer",
    style: {
      width: 0,
      height: 0,
      border: 'none'
    }
  }), downloadEnabled ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
    id: "csvForm",
    target: "csvContainer",
    action: getSummaryUrl(),
    method: "post"
  }, /*#__PURE__*/React.createElement("input", {
    className: "t-s-token",
    type: "hidden",
    name: "access_token",
    value: getUser().access_token
  }))) : null);
};
Summary.propTypes = {
  settings: PropTypes.shape({
    settings: PropTypes.shape({
      indexDefinitions: PropTypes.shape({})
    })
  }).isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedSummary: PropTypes.shape({
    query: PropTypes.string,
    hasStart: PropTypes.number,
    hasStop: PropTypes.number,
    name: PropTypes.string,
    note: PropTypes.string,
    identifier: PropTypes.string,
    hasWeekEnding: PropTypes.number,
    hasJob: PropTypes.number
  }).isRequired,
  notificationActions: PropTypes.shape({
    success: PropTypes.func,
    validationError: PropTypes.func
  }).isRequired,
  summaryFilterOptions: PropTypes.shape({
    currentSummary: PropTypes.string,
    currentFilter: PropTypes.string
  }),
  summaryFilterOptionsActions: PropTypes.shape({
    serverFilter: PropTypes.func
    // pageNext: PropTypes.func,
  }).isRequired
};
export { Summary as TestSummary };
export default entityComposition(Summary, ['summary', 'summaryFilterOptions', 'settings'], {}, ['notification']);